export default "__VITE_ASSET__ChnH92wN__"